/** Fictional, fixed examples for the homepage. Never read customer data. */
export const MONITORING_ASSESSMENTS = [
  {
    account: 'Quillstack',
    priority: 'Act now',
    summary: 'A growing sales team. A stated research need.',
    headline: 'The team is growing. Research is slowing it down.',
    reasoning:
      'Sales hiring and a revenue leader’s request for better account research point to a relevant conversation—not just a company announcement.',
    evidence: [
      {
        kind: 'Company',
        source: 'Careers page',
        date: 'Sep 5',
        dateTime: '2026-09-05',
        finding: 'Enterprise sales and revenue operations roles opened.'
      },
      {
        kind: 'Buying group',
        source: 'Revenue leader’s post',
        date: 'Sep 7',
        dateTime: '2026-09-07',
        finding:
          'Nadia Brooks asked peers how they reduce manual account research.'
      }
    ],
    nextStep:
      'Ask Nadia where research slows the team down. Lead with that problem.',
    caveat: 'A stated problem is a reason to talk, not a confirmed purchase.'
  },
  {
    account: 'Brightvault',
    priority: 'Look into it',
    summary: 'GTM expansion, without an explicit buying signal.',
    headline: 'A new team creates a reason to investigate.',
    reasoning:
      'A new commercial leader and committee engagement with hiring posts suggest expansion. Neither establishes a need for a new tool.',
    evidence: [
      {
        kind: 'Company',
        source: 'Company announcement',
        date: 'Sep 4',
        dateTime: '2026-09-04',
        finding: 'A new commercial leader joined to build the enterprise team.'
      },
      {
        kind: 'Buying group',
        source: 'Committee reactions',
        date: 'Sep 8',
        dateTime: '2026-09-08',
        finding: 'Sales leaders engaged with their own company’s hiring posts.'
      }
    ],
    nextStep:
      'Check whether the new team has an account-research problem before pitching.',
    caveat: 'Limited evidence. Reactions do not establish buying intent.'
  },
  {
    account: 'Cedarpath',
    priority: 'Keep in view',
    summary: 'Company activity, but no clear reason to prioritize.',
    headline: 'An active company. No clear opening yet.',
    reasoning:
      'Routine product updates add context, but the available company and committee evidence does not support moving this account up the list.',
    evidence: [
      {
        kind: 'Company',
        source: 'Product update',
        date: 'Sep 3',
        dateTime: '2026-09-03',
        finding: 'A routine product release introduced new reporting options.'
      },
      {
        kind: 'Buying group',
        source: 'Available public activity',
        date: 'Sep 9',
        dateTime: '2026-09-09',
        finding: 'No explicit research need appeared in the activity checked.'
      }
    ],
    nextStep:
      'Keep the account in the next scheduled review. Focus elsewhere for now.',
    caveat: 'Coverage may be incomplete. No finding does not mean no need.'
  }
] as const;

export type MonitoringAssessment = (typeof MONITORING_ASSESSMENTS)[number];

export function nextMonitoringAssessment(index: number): number {
  return (index + 1) % MONITORING_ASSESSMENTS.length;
}
